<form [formGroup]="filterForm" class="card-form" (ngSubmit)="onApplyFilters()">
  <pa-info-block *ngIf="config?.grouping">
    <div class="grouping-block">
      <div class="grouping-title">Настройка отображения</div>

      <pa-select
        *ngIf="config?.grouping?.fields?.length"
        [formControlName]="groupingFormKey"
        [attr.data-filter-key]="groupingFormKey"
        [label]="config.grouping.fields[0].label"
        [options]="config.grouping.fields[0].options"
        optionLabel="name"
        placeholder="Выберите группировку"
      ></pa-select>
    </div>
  </pa-info-block>

  <pa-info-block *ngIf="filterFields.length">
    <div class="card-form">
      <div *ngFor="let field of filterFields">
        <pa-input
          *ngIf="field.filterType === 'input'"
          [formControlName]="field.dataKey"
          [attr.data-filter-key]="field.dataKey"
          [label]="field.label"
          [hint]="field.hint"
          [placeholder]="field.placeholder"
          (keydown.enter)="onApplyFilters()"
        ></pa-input>

        <pa-select
          *ngIf="field.filterType === 'select'"
          [formControlName]="field.dataKey"
          [attr.data-filter-key]="field.dataKey"
          [label]="field.label"
          [hint]="field.hint"
          [showFilter]="field.showFilter"
          [showProfiTag]="!!field.showProfiTag"
          [placeholder]="field.placeholder"
          [options]="field.selectOptions"
          optionLabel="name"
        ></pa-select>

        <pa-autocomplete
          *ngIf="field.filterType === 'autocomplete'"
          [formControlName]="field.dataKey"
          [attr.data-filter-key]="field.dataKey"
          [suggestions]="field.selectOptions"
          [filterMethod]="field.completeMethod"
          [label]="field.label"
          [hint]="field.hint"
          [placeholder]="field.placeholder"
        ></pa-autocomplete>

        <pa-multi-select
          *ngIf="field.filterType === 'multi-select'"
          [formControlName]="field.dataKey"
          [attr.data-filter-key]="field.dataKey"
          [label]="field.label"
          [hint]="field.hint"
          [showFilter]="field.showFilter"
          [placeholder]="field.placeholder"
          [options]="field.selectOptions"
          optionLabel="name"
        ></pa-multi-select>

        <pa-datepicker
          *ngIf="field.filterType === 'date'"
          [formControlName]="field.dataKey"
          [attr.data-filter-key]="field.dataKey"
          [label]="field.label"
          [hint]="field.hint"
          [placeholder]="field.placeholder"
        ></pa-datepicker>

        <pa-datepicker
          *ngIf="field.filterType === 'month'"
          [formControlName]="field.dataKey"
          [attr.data-filter-key]="field.dataKey"
          [label]="field.label"
          [hint]="field.hint"
          [placeholder]="field.placeholder"
          view="month"
        ></pa-datepicker>

        <pa-datepicker-range-period
          *ngIf="field.filterType === 'date-range'"
          [formControlName]="field.dataKey"
          [attr.data-filter-key]="field.dataKey"
          [label]="field.label"
          [hint]="field.hint"
          [placeholder]="field.placeholder"
          [periodOptions]="field.dateRangePeriodOptions"
        ></pa-datepicker-range-period>
      </div>
    </div>
  </pa-info-block>
</form>
